import React from 'react';
import { List, Label, Icon } from 'semantic-ui-react';
import { formatDistanceToNow } from 'date-fns';
import './ConversationPreview.css';

/** Unescape HTML entities from validator.escape() */
const unescapeHtml = (str) => {
  if (!str) return str;
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return doc.documentElement.textContent;
};

const ConversationPreview = ({ conversation, isSelected, onClick }) => {
  const {
    otherParticipant,
    latestMessage,
    lastMessageTime,
    unreadCount,
    threadCount
  } = conversation;

  const formatTime = (timestamp) => {
    try {
      const date = new Date(timestamp);
      return formatDistanceToNow(date, { addSuffix: true });
    } catch (error) {
      return 'Recently';
    }
  };

  const truncateMessage = (content, maxLength = 60) => {
    if (!content) return 'No messages yet';
    const decoded = unescapeHtml(content);
    return decoded.length > maxLength
      ? decoded.substring(0, maxLength) + '...'
      : decoded;
  };

  const getMessageTypeIcon = (messageType) => {
    switch (messageType) {
      case 'OPPORTUNITY_INQUIRY':
        return 'briefcase';
      case 'APPLICATION_RESPONSE':
        return 'file alternate';
      case 'SYSTEM':
        return 'cog';
      default:
        return 'comment';
    }
  };

  const handleClick = () => {
    onClick(null); // Start with general conversation, user can switch threads
  };

  return (
    <List.Item
      className={`conversation-preview ${isSelected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      <div className="conversation-preview-content">
        <div className="conversation-header">
          <div className="participant-info">
            <div className="participant-name">
              {otherParticipant.name || otherParticipant.email}
            </div>
            <div className="conversation-meta">
              <span className="last-message-time">
                {formatTime(lastMessageTime)}
              </span>
              {threadCount > 1 && (
                <span className="thread-count">
                  <Icon name="list" size="small" />
                  {threadCount} threads
                </span>
              )}
            </div>
          </div>

          <div className="conversation-indicators">
            {unreadCount > 0 && (
              <Label circular color="blue" size="mini">
                {unreadCount > 99 ? '99+' : unreadCount}
              </Label>
            )}
          </div>
        </div>

        <div className="latest-message">
          <div className="message-preview">
            <Icon
              name={getMessageTypeIcon(latestMessage?.messageType)}
              size="small"
              className="message-type-icon"
            />
            <span className="message-content">
              {truncateMessage(latestMessage?.content)}
            </span>
          </div>

          {latestMessage?.messageType !== 'GENERAL' && (
            <div className="message-context">
              <Label size="mini" basic>
                {latestMessage?.messageType?.replace('_', ' ').toLowerCase()}
              </Label>
            </div>
          )}
        </div>
      </div>
    </List.Item>
  );
};

export default ConversationPreview;
